import { TextLink } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import React, { useEffect, useState, useRef } from 'react';

export const skipToContentMessage = {
  defaultMessage: 'Skip to Content',
  id: 'fa.quick-access-links.skip-to-content',
};

export const ContentLink: React.FC = () => {
  const [isFocused, setIsFocused] = useState(false);

  // workaround for lighthouse
  const isLighthouse = useRef(false);
  useEffect(() => {
    isLighthouse.current = window.location.search.includes('lighthouse=true');

    if (isLighthouse.current) {
      setIsFocused(true);
    }
  }, []);

  const handleBlur = () => {
    if (!isLighthouse.current) {
      setIsFocused(false);
    }
  };

  const linkText = useI18n(skipToContentMessage);

  return (
    <>
      <div
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={handleBlur}
        style={{
          opacity: isFocused ? 1 : 0,
          height: isFocused ? 'auto' : 0,
          overflow: 'hidden',
          transition: 'all 0.6s ease',
          top: 0,
          left: 0,
          zIndex: 1000,
        }}
      >
        <TextLink
          aria-label={linkText}
          href="#main-content"
          icon="external-link"
          iconPosition="leading"
          id="skip-to-content-link"
          rel="noopener"
          size="md"
          target="_self"
          variant="standalone"
        >
          {linkText}
        </TextLink>
      </div>
    </>
  );
};
